﻿﻿﻿<chairlift-menu (outputDownload)="downloadChairliftFiltered()" (onReload)="onReload()"></chairlift-menu>
<h2>{{title}} for {{defaults.tenant}}</h2>
<chairlift-filter (outputFilter)="getFilteredChairliftsByTenant()"></chairlift-filter>
<chairlift-list [list]="list" [showLocalFilter]="showLocalFilter"></chairlift-list>